import React, { Component } from "react";
import { Row, Col, Table, Tooltip, OverlayTrigger } from "react-bootstrap";
import moment from "moment";
import Card from "components/Card/Card.jsx";
import CustomButtom from "components/CustomButton/CustomButton.jsx";
import { fetchIncomeTaxesRequest, deleteIncomeTaxRequest } from "../../../api/incomeTax";
import { formatCurrency } from "../../../helpers/functions/currency.js";

class IncomeTaxTable extends Component {

  state = {
    data: null,
    error: null,
    loading: false
  };

  componentDidMount() {
    if (!this.state.data && this.props.selectedEffectiveDate)
      this.fetchIncomeTaxData()
  }

  componentDidUpdate(prevProps) {
    if(prevProps.selectedEffectiveDate !== this.props.selectedEffectiveDate) {
      this.fetchIncomeTaxData();
    }
  }

  fetchIncomeTaxData(){
    this.setState({
      loading: true
    });

    fetchIncomeTaxesRequest(
      this.props.selectedEffectiveDate,
      result => this.setState({data: result, error: null, loading: false}),
      error => this.setState({error: error.message, loading: false})
    )
  };

  deleteIncomeTax = (id) => {
    deleteIncomeTaxRequest(
      id,
      result => this.fetchIncomeTaxData(),
      error =>
        this.setState({ error: "There was an error deleting instance" })
    );
  }

  render() {
    const { data } = this.state;
    const { selectedEffectiveDate } = this.props;
    const view = <Tooltip id="view_tooltip">View</Tooltip>;
    const edit = <Tooltip id="edit_tooltip">Edit</Tooltip>;
    const remove = <Tooltip id="remove_tooltip">Remove</Tooltip>;

    return (
      <div className="content">
          <Row>
            <Col md={12}>
              <Card
                title="Income Tax Table"
                category="List of Income Tax entries to DB"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div>
                    <CustomButtom className="table-top-btn btn-primary" onClick={() => this.props.goToCreateForm('income-tax')}>
                      New Group
                    </CustomButtom>
                    {!!selectedEffectiveDate && <Table striped hover>
                      <thead>
                        <tr>
                          <th>Annual Salary From</th>
                          <th>Annual Salary To</th>
                          <th>Tax Fixed Amount</th>
                          <th>Tax Rate</th>
                          <th>Exempt amount</th>
                          {/* <th>Total Contribution</th> */}
                          <th>Effective Date</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading 
                        ? <td colSpan="7" style={{padding: "0"}}>
                            <div className="loader"></div>
                          </td> 
                        : data && data.length > 0 
                          ? data.map(instance => {
                              return (
                                <tr key={instance._id}>
                                  <td>{formatCurrency(instance.annualSalaryFrom) || 0}</td>
                                  <td>{formatCurrency(instance.annualSalaryTo) || "N/A"}</td>
                                  <td>{formatCurrency(instance.taxFixedAmount) || 0}</td>
                                  <td>{instance.taxRate || 0}</td>
                                  <td>{formatCurrency(instance.exemptAmount) || 0}</td>
                                  <td>{instance.effectiveDate ? moment.utc(instance.effectiveDate).format('MM/DD/YYYY') : "N/A"}</td>
                                  <td className="td-actions text-right">
                                    <OverlayTrigger placement="top" overlay={view}>
                                      <CustomButtom 
                                        bsStyle="success" 
                                        simple 
                                        type="button" 
                                        bsSize="xs"
                                        onClick={() => this.props.goToDetails('income-tax', instance._id)}
                                      >
                                        <i className="fa fa-eye" />
                                      </CustomButtom>
                                    </OverlayTrigger>

                                    <OverlayTrigger placement="top" overlay={edit}>
                                      <CustomButtom 
                                        bsStyle="info" 
                                        simple 
                                        type="button" 
                                        bsSize="xs"
                                        onClick={() => this.props.goToEditForm('income-tax', instance._id)}
                                      >
                                        <i className="fa fa-edit" />
                                      </CustomButtom>
                                    </OverlayTrigger>

                                    <OverlayTrigger placement="top" overlay={remove}>
                                      <CustomButtom 
                                        bsStyle="danger" 
                                        simple 
                                        type="button" 
                                        bsSize="xs"
                                        onClick={() => this.deleteIncomeTax(instance._id)}
                                      >
                                        <i className="fa fa-times" />
                                      </CustomButtom>
                                    </OverlayTrigger>
                                  </td>
                                </tr>
                              )}
                            )
                          : (
                            <tr>
                              <td colSpan='7'>There are no instances in the database yet.</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </Table>}
                  </div>
                }
              />
            </Col>
          </Row>
      </div>
    );
  }
}

export default IncomeTaxTable;
